var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ElPopover",
    {
      attrs: {
        value: _vm.showSuggestion,
        "visible-arrow": false,
        "popper-class": "patsnap-biz-email-input__suggestion-popover",
        trigger: "manual",
        placement: "bottom",
      },
    },
    [
      _c(
        "div",
        {
          ref: "searchInput",
          class: {
            "patsnap-biz-email-input": true,
            "patsnap-biz-email-input-error":
              _vm.isSomeoneEmailInvalid || _vm.service.isEmailError,
          },
          style: { width: _vm.service.width },
          attrs: { slot: "reference" },
          slot: "reference",
        },
        [
          _c(
            "div",
            {
              ref: "wrapper",
              class: {
                "patsnap-biz-email-input__users-input": true,
                "patsnap-biz-email-input__users-input--active": _vm.isFocus,
              },
              on: { click: _vm.onFocus },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isPlaceholderDisplay,
                      expression: "isPlaceholderDisplay",
                    },
                  ],
                  staticClass:
                    "patsnap-biz-email-input__users-input__placeholder",
                },
                [_vm._v(" " + _vm._s(_vm.service.placeholder) + " ")]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "patsnap-biz-email-input__users-input__container",
                },
                [
                  _vm._l(_vm.userEmailSelectedDisplay, function (user, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        class: {
                          "patsnap-biz-email-input__users-input__item": true,
                          "patsnap-biz-email-input__users-input__item--error":
                            !user.isValid,
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                          },
                        },
                      },
                      [
                        user.isValid
                          ? _c(
                              "span",
                              {
                                class: {
                                  "patsnap-biz-email-input__users-input__item-avator": true,
                                  "patsnap-biz-email-input__users-input__item-avator--group":
                                    user.type === "group",
                                },
                                style: {
                                  "background-color": _vm.getSuggestionColor(
                                    user.displayLabel.slice(0, 1)
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      user.displayLabel
                                        .slice(0, 1)
                                        .toUpperCase()
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "span",
                          {
                            staticClass:
                              "patsnap-biz-email-input__users-input__item-text",
                          },
                          [_vm._v(_vm._s(user.displayLabel))]
                        ),
                        _c("PtIcon", {
                          staticClass:
                            "patsnap-biz-email-input__users-input__item-close",
                          attrs: { icon: "SolidCloseMedium" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.onRemoveSelected(user)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  _vm.hasSelectedEmail
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.currentInputing,
                            expression: "currentInputing",
                          },
                        ],
                        ref: "input",
                        staticClass:
                          "patsnap-biz-email-input__users-input__invisible-input",
                        attrs: {
                          type: "text",
                          spellcheck: "false",
                          autocomplete: "no",
                        },
                        domProps: { value: _vm.currentInputing },
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              $event.keyCode !== 188
                            ) {
                              return null
                            }
                            return _vm.onInputPush.apply(null, arguments)
                          },
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.preventDefault()
                            return _vm.onInputPush.apply(null, arguments)
                          },
                          blur: _vm.onInputBlur,
                          input: [
                            function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.currentInputing = $event.target.value
                            },
                            _vm.onInputChange,
                          ],
                        },
                      })
                    : _vm._e(),
                ],
                2
              ),
            ]
          ),
          _vm.service.isEmailError && _vm.service.errorMsg
            ? _c("div", { staticClass: "patsnap-biz-email-input__error-msg" }, [
                _vm._v(" " + _vm._s(_vm.service.errorMsg) + " "),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "clickoutside",
              rawName: "v-clickoutside",
              value: _vm.closeSuggestList,
              expression: "closeSuggestList",
            },
          ],
          ref: "autoCompleteBody",
          staticClass: "patsnap-biz-email-input__suggest",
          style: "width:" + _vm.suggestWidth + "px",
          on: {
            mousedown: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _vm.isLoading
            ? _c(
                "div",
                { staticClass: "patsnap-biz-email-input__suggest-loading" },
                [_c("PtIcon", { attrs: { icon: "SolidLoadingBars" } })],
                1
              )
            : _vm.nodata
            ? _c(
                "div",
                { staticClass: "patsnap-biz-email-input__suggest-nodata" },
                [_vm._v(" " + _vm._s(_vm.nodataDisplayLabel) + " ")]
              )
            : [
                _c(
                  "div",
                  { staticClass: "patsnap-biz-email-input__suggest-content" },
                  _vm._l(_vm.userEmailDisplayList, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass:
                          "patsnap-biz-email-input__suggest-content-item",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.onSelect(item)
                          },
                        },
                      },
                      [
                        _vm._t(
                          "icon",
                          function () {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "patsnap-biz-email-input__suggest-content-item-avator",
                                  style: {
                                    "background-color": _vm.getSuggestionColor(
                                      item.firstLatter
                                    ),
                                  },
                                },
                                [_vm._v(" " + _vm._s(item.firstLatter) + " ")]
                              ),
                            ]
                          },
                          { item: item }
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "patsnap-biz-email-input__suggest-content-item-text",
                          },
                          [
                            item.nickname
                              ? _c("p", {
                                  staticClass: "nick-name",
                                  domProps: {
                                    innerHTML: _vm._s(item.nicknameDisplay),
                                  },
                                })
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "user-info" },
                              [
                                item.email
                                  ? _c(
                                      "ElPopover",
                                      {
                                        attrs: {
                                          placement: "top",
                                          trigger: "hover",
                                          "visible-arrow": false,
                                          "open-delay": 200,
                                          "close-delay": 0,
                                          "popper-class":
                                            "patsnap-biz-email-input__popover",
                                        },
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "user-info-email",
                                          attrs: { slot: "reference" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              item.emailDisplay
                                            ),
                                          },
                                          slot: "reference",
                                        }),
                                        _c("p", {
                                          staticStyle: { "max-width": "500px" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              item.emailDisplay
                                            ),
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                item.mobile_number
                                  ? _c("span", {
                                      staticClass: "user-info-mobile-number",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          item.mobileNumberDisplay
                                        ),
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm.service.companyMode
                              ? _c("div", { staticClass: "company-info" }, [
                                  item.company_name
                                    ? _c("span", {
                                        staticClass: "company-info-name",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            item.companyNameDisplay
                                          ),
                                        },
                                      })
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ]
                        ),
                      ],
                      2
                    )
                  }),
                  0
                ),
              ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }